The end date of the position if known.

This may only contain the year and month, e.g. `2020-01`.
